import { Data } from './data.model';
export class TreeObject {
    data?: Data;
    children?: TreeObject[];
    leaf?: boolean;
    expanded?: boolean;
    parent?:TreeObject;
}